//@ actions
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const { handleFieldChange } = require('actions/brokerProductFiltersSearch');
const { advancedSearchProducts, searchSpecificProduct, setSpecificProduct } = require('./brokerProductAdvancedSearch');

//@Constants
const actionTypes = require('constants/actionTypes');
const {
    BROKER_SIMPLE_SEARCH_PAGE_NUM,
    BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT_3,
    BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT,
    BROKER_PRODUCT_ADVANCED_SEARCH_TERM
} = require('constants/index');

//@helpper
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

const changeSearchInput = (search) => (dispatch) => {
    dispatch(handleFieldChange(BROKER_PRODUCT_ADVANCED_SEARCH_TERM, search));
    dispatch({
        type: actionTypes.BROKER_SEARCH_WIDGET_CHANGE_INPUT,
        payload: {
            search
        }
    });
};

const clearResults = () => (dispatch) => {
    dispatch({type: actionTypes.BROKER_SEARCH_WIDGET_CLEAR_RESULTS});
};

const hideSearchWidget = () => (dispatch) => {
    dispatch({type: actionTypes.BROKER_SEARCH_WIDGET_HIDE});
};

const reset = () => (dispatch) => {
    dispatch({type: actionTypes.BROKER_SEARCH_WIDGET_RESET});
};

const searchAdvancedProducts = (product) => (dispatch) => {
    if (!!product) {
        dispatch(searchSpecificProduct(product));
    } else {
        dispatch(advancedSearchProducts());
    }
}

const setFilterProduct = (product) => (dispatch) => {
    dispatch(setSpecificProduct(product));
}

const searchProductsFailure = (response) => {
    return {
        type: actionTypes.BROKER_SEARCH_WIDGET_FAILURE,
        payload: {
            data: response
        }
    };
};

const searchProductsRequest = () => {
    return {
        type: actionTypes.BROKER_SEARCH_WIDGET_REQUEST
    };
};

const searchProductsSuccess = (response, term) => (dispatch, getState) => {
    dispatch ({
        type: actionTypes.BROKER_SEARCH_WIDGET_SUCCESS,
        payload: {
            data: {
                ...response,
                term
            }
        }
    });
    const searchEmptyWritting = getState().brokerSearchWidget.get('searchEmpty');
    dispatch ({
        type: actionTypes.BROKER_SEARCH_WIDGET_SUCCESS_TRACKING,
        payload: {
            term,
            searchEmptyWritting
        }
    });
};

const searchProducts = (term, product, searchLimit = BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT_3) => (dispatch) => {
    const header = __CONTACT_CENTER__ ? {
        isOfficeAgent: isPrintOfficeMode() ? 'office' : 'CC'
    } : null;
    let requestData = {
        header: header,
        query: {
            text: term,
            pageSize: searchLimit,
            pageNumber: BROKER_SIMPLE_SEARCH_PAGE_NUM
        }
    };
    let url = apiURLBuilder.getURL('catalogueBrokerSimpleSearch');

    if (!!product) {
        url = apiURLBuilder.getURL('catalogueBrokerAdvancedSearch');
        requestData.query.products = product.toUpperCase();
        requestData.query.pageSize = BROKER_PRODUCT_SEARCH_OPTIONS_LIMIT;
    }

    dispatch(searchProductsRequest(term));

    return APIGet(dispatch, url, requestData)
        .then(response => {
            dispatch(searchProductsSuccess(response, term));
        }, response => {
            dispatch(searchProductsFailure(response, term));
        }
    );
};

const showSearchWidget = () => ({
    type: actionTypes.BROKER_SEARCH_WIDGET_SHOW
});


module.exports = {
    changeSearchInput,
    clearResults,
    hideSearchWidget,
    reset,
    searchAdvancedProducts,
    searchProducts,
    setFilterProduct,
    showSearchWidget
};
